import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.string.replace.js";
import { AccountCategory, Module, useGetAccountQuery, useGetUserQuery } from '~/types/types';
import { isAccountAdminForAccount } from '~/functions/membership-role';
import { usePortfolioReviewContext } from '~/functions/review';
export function useAccountUsersPage(options) {
  var _options$allowIxAdmin;
  var router = useRouter();
  var _useNuxtApp = useNuxtApp(),
    $auth = _useNuxtApp.$auth;
  var allowIxAdmin = (_options$allowIxAdmin = options.allowIxAdmin) !== null && _options$allowIxAdmin !== void 0 ? _options$allowIxAdmin : false;
  var _usePortfolioReviewCo = usePortfolioReviewContext(),
    portfolioLandingPath = _usePortfolioReviewCo.portfolioLandingPath;
  var _useGetUserQuery = useGetUserQuery(),
    userResult = _useGetUserQuery.result,
    userLoading = _useGetUserQuery.loading;
  var user = computed(function () {
    var _userResult$value;
    return (_userResult$value = userResult.value) === null || _userResult$value === void 0 ? void 0 : _userResult$value.getUser;
  });
  var accountQueryEnabled = computed(function () {
    return $auth.loggedIn && Boolean(options.accountId.value);
  });
  var _useGetAccountQuery = useGetAccountQuery(computed(function () {
      return {
        id: options.accountId.value
      };
    }), computed(function () {
      return {
        enabled: accountQueryEnabled.value
      };
    })),
    accountResult = _useGetAccountQuery.result,
    accountLoading = _useGetAccountQuery.loading;
  var account = computed(function () {
    var _accountResult$value;
    return (_accountResult$value = accountResult.value) === null || _accountResult$value === void 0 ? void 0 : _accountResult$value.getAccount;
  });
  var isIxAdminSession = computed(function () {
    var _user$value, _user$value2;
    return Boolean((_user$value = user.value) === null || _user$value === void 0 ? void 0 : _user$value.isAdmin) && !((_user$value2 = user.value) !== null && _user$value2 !== void 0 && _user$value2.isImpersonated);
  });
  var isAccountAdmin = computed(function () {
    return isAccountAdminForAccount(account.value);
  });
  var canAccess = computed(function () {
    return allowIxAdmin && isIxAdminSession.value || isAccountAdmin.value;
  });
  var loading = computed(function () {
    return userLoading.value || accountLoading.value;
  });
  var listUsersFilter = computed(function () {
    if (allowIxAdmin && isIxAdminSession.value) {
      return {};
    }
    return options.accountId.value ? {
      accountId: options.accountId.value
    } : {};
  });
  var disableReviewerRole = computed(function () {
    var _acct$modules;
    var acct = account.value;
    if (!acct) {
      return true;
    }
    return acct.type !== AccountCategory.Portfolio || !((_acct$modules = acct.modules) !== null && _acct$modules !== void 0 && _acct$modules.includes(Module.Review));
  });
  var userTableColumns = computed(function () {
    var base = ['email', 'firstName', 'lastName', 'lastLogin'];
    if (allowIxAdmin && isIxAdminSession.value) {
      return [].concat(base, ['isIxAdmin', 'accounts']);
    }
    return [].concat(base, ['roles', 'actions']);
  });
  var defaultRedirectPath = computed(function () {
    var acct = account.value;
    var id = options.accountId.value;
    if ((acct === null || acct === void 0 ? void 0 : acct.type) === AccountCategory.Venture && id) {
      return "/".concat(id, "/modules");
    }
    return portfolioLandingPath.value;
  });
  watch([loading, canAccess, account], function () {
    var _options$redirectPath;
    if (loading.value || canAccess.value) {
      return;
    }
    if (!account.value) {
      router.replace('/');
      return;
    }
    router.replace(((_options$redirectPath = options.redirectPath) === null || _options$redirectPath === void 0 ? void 0 : _options$redirectPath.value) || defaultRedirectPath.value);
  }, {
    immediate: true
  });
  return {
    account: account,
    loading: loading,
    canAccess: canAccess,
    isIxAdminSession: isIxAdminSession,
    isAccountAdmin: isAccountAdmin,
    listUsersFilter: listUsersFilter,
    disableReviewerRole: disableReviewerRole,
    userTableColumns: userTableColumns
  };
}